export const modalWidth = 280;

export const getFeatureTourPosition = (targetElement: HTMLDivElement) => {
    const rect = targetElement.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const right = 20;

    let modalLeft = rect.left + rect.width / 2 - 100;
    const modalTop =
        rect.bottom + 10 < viewportHeight ? rect.bottom + 10 + window.scrollY : rect.top - 10 - 50 + window.scrollY;

    modalLeft = Math.max(20, Math.min(modalLeft, viewportWidth - modalWidth - right));

    return { top: modalTop, left: modalLeft };
};
